import Item from './Item';

export default class Portal extends Item {
  constructor() {
    super(6);
  }
}



// WEBPACK FOOTER //
// ./src/models/Portal.js